"use strict";

exports.__esModule = true;
exports["default"] = MobileComputing;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function MobileComputing(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M373.6 1H136.3C114.5 1 97 21.5 97 46.7v418.7c0 25.3 17.5 45.6 39.3 45.6h237.3c21.7 0 39.4-20.3 39.4-45.6V46.7C413 21.5 395.4 1 373.6 1zm-83.5 457.2h-70.2c-14.6 0-35.1-2.4-35.1-17.6 0-15.2 20.6-17.6 35.1-17.6h70.2c14.6 0 35.1 2.4 35.1 17.6 0 15.3-20.6 17.6-35.1 17.6zm87.8-105.5c0 21.7-16.6 35.2-35.1 35.2H167.2c-18.6 0-35.1-13.5-35.1-35.2V71.3c0-21.6 16.5-35.2 35.1-35.2h175.6c18.6 0 35.1 13.6 35.1 35.2v281.4z"
  }));
}